import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Table, Pagination } from "antd";
import axios from "axios";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../../components/SearchBox";
import GradesModal from "../../../../components/modelpopup/DepartmentModal";
import { base_url } from "../../../../base_urls";
import {
  itemRender,
  pageSizeOptions,
  handlePageChange,
  defaultPagination
} from "utils/table";
import { useMediaQuery } from "react-responsive";
import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";


import {getGrades} from "api/services/common"
import { useSearchParams } from 'react-router-dom';
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";


const Grades = () => {
  const [gradesData, setGradesData] = useState([])
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [view, setView] = useState(isMobile? "grid":"list");

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})


const handleRowClick = (record) => {
  navigate(`/grades/${record.id}`); 
};


const handleChange = (pagination, filters, sorter) => {
  let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
  console.log(pageData)
  // setSearchParams({
  //     size: pageData?.pageSize,
  //     page: pageData?.page,
  //     sort_by: pageData?.sortBy || "",
  //     sort_type: pageData?.sortType || ""
  // })
  setPageSettings(pageData)
};


const getGradesList = () => {
  setLoading(true)

  // let _filters = [...filters].filter(item=> item.value)
  // const filter_params = _filters.reduce((acc, item) => {
  //     acc[item.key] = item.value;
  //     return acc;
  //   }, {});
  let filter_params = {}

    
  getGrades({
    sort_by:pageSettings?.sortBy,
    sort_type: pageSettings?.sortType,
    page_size: pageSettings?.pageSize,
    page: pageSettings?.page,
    ...filter_params

  }).then(response=>{
    console.log(response.data.results)
    setGradesData(response.data.results);
    setPageSettings({
      ...pageSettings,
      total: response.data.count
    })

    setLoading(false)
  }).catch(e=>{
    setLoading(false)
  })
}
useEffect(()=>{

getGradesList()

},[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])



  const columns = [
    {
      title: "Code",
      dataIndex: "grade_code",
      sorter: true,
      // width:   "10%",
    },
    {
      title: "Name",
      dataIndex: "grade_name",
      sorter: (a, b) => true,
      // width: "50%",
    },
  
    {
      title: "Minimum Salary",
      dataIndex: "minimum_salary",
      align: "center" 
    },
    {
      title: "Maximum Salary",
      dataIndex: "maximum_salary",
      align: "center" 
    },
    {
      title: "Leave Benefits",
      dataIndex: "leave_benefits", 
      align: 'center'
    },
 

   
    // {
    //   title: "Action",
    //   className: "text-end",
    //   render: () => (
    //     <div className="dropdown dropdown-action text-end">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_department"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link>
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#delete"
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    //   sorter: (a, b) => a.length - b.length,
    //   width: "10%",
    // },
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {gradesData.map((grade, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6">
            <div className="contact-grid">
                
                <div className="grid-body">
                        <span>
                            {grade?.grade_name}
                            {/* sharon@gmail.com */}
                        </span>
                        <br/>
                        <span>
                            {grade?.grade_code}
                        </span>
                        <br/>
                        <span>
                            Min Salary : {grade?.minimum_salary}
                        </span>
                        <br/>
                        <span>
                            Max Salary : {grade?.maximum_salary}
                        </span>
                       
                   
                </div>
               
            </div>
        </div>
         
          ))}
        </>
      );
    }
  };

  
  const handleGridChange = (page, size) => {
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Others"
            title="Dashboard"
            subtitle="Grades"
            modal="#add_grades"
            name="Add Grade"

            view={view}
            setView={setView}

          />
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              {
                view === "grid" ? 
                <div className="row">
              
                <GridView />
  
                <div className="my-2 d-flex justify-content-end ">
                  <div className="col-sm-12 col-md-6 ">
                  <Pagination
  
                      pageSize={pageSettings?.pageSize}
                      pageSizeOptions={pageSizeOptions}
                      defaultCurrent={1}
                      current={pageSettings?.page}
                      total={pageSettings?.total}
                      // itemRender={itemRender}
                      onChange={handleGridChange}
  
                      showLessItems
                      showSizeChanger={false}
                      showQuickJumper={false}
                      hideOnSinglePage
                      itemRender={(page, type, originalElement) => {
                        if (type === "next") {
                          return (
                            <Button
                              loading={loading}
                              // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                              className="btn btn-primary "
                              // type="Load More"
                              label="Load More"
                            />
                            
                          );
                        }
                        return null;
                      }}
  
                      />
                  
                  </div>
                </div>
              </div>
              :
<div className="table-responsive">
                {/* <SearchBox /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={gradesData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                  onRow={(record) => ({
                    onClick: () => handleRowClick(record),
                    style: { cursor: "pointer" }, // Change cursor on hover
                  })}
                />
              </div>
              }
              
            </div>
          </div>
        </div>
      </div>

      <GradesModal />
      <DeleteModal Name="Delete Grade" />
    </>
  );
};

export default Grades;
